import styled from 'styled-components';
import { HIDE_SCROLL_BAR } from '../../../../common/styles/mixins';
import { onMobile } from '../../../../common/styles/onMobile';

export const ImportantInformationContainer = styled.div`
  ${HIDE_SCROLL_BAR};
  margin-top: 10px;
  ${onMobile} {
    overflow-y: auto;
    white-space: nowrap;
  }
`;
